export default "__VITE_ASSET__ByryBAVX__"